// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class QuoteDelay {
    constructor() {
        this.delayBySubscribeType = new Map();
    }
    SetDelay(delay, subscribeType) {
        this.delayBySubscribeType.set(subscribeType, delay);
    }
    GetDelay(subscribeType) {
        const delay = this.delayBySubscribeType.get(subscribeType);
        return !isNullOrUndefined(delay) ? delay : 0;
    }
    HasDelay(subscribeType) {
        const delay = this.GetDelay(subscribeType);
        return delay > 0;
    }
    Clear() {
        this.delayBySubscribeType.clear();
    }
}
